import React from 'react';
import FormsCarousel from './FormsCarousel';

class Forms extends React.Component {

    render() {
        return (
            <section className="wrap-top" id="forms">

                <div className="content">
                    <svg className="forms-bg-top" version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330 296"
                         width="330" height="296" fill="currentColor">
                        <g id="Layer 1">
                            <g id="&lt;Group&gt;">
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" class="s0"
                                          d="m33.6 106.4l-28.2-18.3v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m38.5 106.4l28.2 18.4v-36.7z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m119.6 106.4l-28.2-18.3v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m124.5 106.4l28.2 18.4v-36.7z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m205.6 106.4l-28.2-18.3v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m210.5 106.4l28.2 18.4v-36.7z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m291.6 106.4l-28.2-18.3v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m296.5 106.4l28.2 18.4v-36.7z"/>
                                </g>
                            </g>
                            <g id="&lt;Group&gt;">
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m33.6 274l-28.2-18.4v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m38.5 274l28.2 18.3v-36.7z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m119.6 274l-28.2-18.4v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m124.5 274l28.2 18.3v-36.7z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m205.6 274l-28.2-18.4v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m210.5 274l28.2 18.3v-36.7z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m291.6 274l-28.2-18.4v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m296.5 274l28.2 18.3v-36.7z"/>
                                </g>
                            </g>
                            <g id="&lt;Group&gt;">
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m33.6 22.7l-28.2-18.4v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m38.5 22.7l28.2 18.3v-36.7z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m119.6 22.7l-28.2-18.4v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m124.5 22.7l28.2 18.3v-36.7z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m205.6 22.7l-28.2-18.4v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m210.5 22.7l28.2 18.3v-36.7z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m291.6 22.7l-28.2-18.4v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m296.5 22.7l28.2 18.3v-36.7z"/>
                                </g>
                            </g>
                            <g id="&lt;Group&gt;">
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m33.6 190.2l-28.2-18.4v36.8z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m38.5 190.2l28.2 18.4v-36.8z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m119.6 190.2l-28.2-18.4v36.8z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m124.5 190.2l28.2 18.4v-36.8z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m205.6 190.2l-28.2-18.4v36.8z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m210.5 190.2l28.2 18.4v-36.8z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m291.6 190.2l-28.2-18.4v36.8z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m296.5 190.2l28.2 18.4v-36.8z"/>
                                </g>
                            </g>
                        </g>
                    </svg>
                    <svg className="forms-bg-btm" version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330 296"
                         fill="currentColor">
                        <g id="Layer 1">
                            <g id="&lt;Group&gt;">
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" class="s0"
                                          d="m33.6 106.4l-28.2-18.3v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m38.5 106.4l28.2 18.4v-36.7z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m119.6 106.4l-28.2-18.3v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m124.5 106.4l28.2 18.4v-36.7z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m205.6 106.4l-28.2-18.3v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m210.5 106.4l28.2 18.4v-36.7z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m291.6 106.4l-28.2-18.3v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m296.5 106.4l28.2 18.4v-36.7z"/>
                                </g>
                            </g>
                            <g id="&lt;Group&gt;">
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m33.6 274l-28.2-18.4v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m38.5 274l28.2 18.3v-36.7z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m119.6 274l-28.2-18.4v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m124.5 274l28.2 18.3v-36.7z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m205.6 274l-28.2-18.4v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m210.5 274l28.2 18.3v-36.7z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m291.6 274l-28.2-18.4v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m296.5 274l28.2 18.3v-36.7z"/>
                                </g>
                            </g>
                            <g id="&lt;Group&gt;">
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m33.6 22.7l-28.2-18.4v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m38.5 22.7l28.2 18.3v-36.7z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m119.6 22.7l-28.2-18.4v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m124.5 22.7l28.2 18.3v-36.7z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m205.6 22.7l-28.2-18.4v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m210.5 22.7l28.2 18.3v-36.7z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m291.6 22.7l-28.2-18.4v36.7z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m296.5 22.7l28.2 18.3v-36.7z"/>
                                </g>
                            </g>
                            <g id="&lt;Group&gt;">
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m33.6 190.2l-28.2-18.4v36.8z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m38.5 190.2l28.2 18.4v-36.8z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m119.6 190.2l-28.2-18.4v36.8z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m124.5 190.2l28.2 18.4v-36.8z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m205.6 190.2l-28.2-18.4v36.8z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m210.5 190.2l28.2 18.4v-36.8z"/>
                                </g>
                                <g id="&lt;Group&gt;">
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m291.6 190.2l-28.2-18.4v36.8z"/>
                                    <path id="&lt;Path&gt;" fill="currentColor" d="m296.5 190.2l28.2 18.4v-36.8z"/>
                                </g>
                            </g>
                        </g>
                    </svg>
                    <h2 className="title" id="formHeader"><span>Forms</span></h2>
                    <div className="forms_list">
                        <FormsCarousel formsList={this.props.formsList} color={this.props.color}
                                       PCBID={this.props.PCBID}/>
                    </div>


                </div>
            </section>
        );
    }
}

export default Forms;